<template>
    <Container type="card-full" drankColor>
        <vggrid :list="psuList" tableheight="600" flexname="" :cols="cols"
                :canbeEdit="iscanbeEdit"
                :showfooter="false" :showPage="false" :resizable="true"
                :total="query.total" @cellClick="cellClick" @cellDblClick="viewProject" @pagechange="pagechange"
        >
        </vggrid>
        <div class="btn">
          <div>
            <el-button style="width:200px;" @click="saveSeq" v-if="iscanbeEdit">提交</el-button>
          </div>
        </div>
    </Container>
</template>
<script>
  import request from '@/utils/request'
  import vggrid from '../../views/common/vggrid'
  import utils from '../../assets/js/utils'

  export default {
    name: 'exSynthesScoringIndex',
    components: {vggrid},
    data () {
      return {
        project: {},
        psuList: [],
        pgstList:[],
        pexertList:[],
        btnLoading: false,
        pexpertInfo:{},
        model: {},
        query: {
          total: 0,
          limit: 20,
          offset: 0
        },
        cols: [
          {field: 'comfullname', fieldtype: 'I', title: '投标人', calculExpr: ''},
          // {field: 'psas', fieldtype: 'I', title: '最终得分', calculExpr: ''},
          // {field: 'psseq', fieldtype: 'I', title: '排名', calculExpr: ''},
          // {field: 'psdesc', fieldtype: 'I', title: '意见', calculExpr: '', editRender: { name: 'input'}}
        ],
        iscanbeEdit:true
      }
    },
    created () {
    },
    activated(){
      this.getModel()
      this.getPexertInfo()
    },
    mounted(){
      this.getAllpfList()
    },
    methods: {
      async getModel () {
        let res = await request({
          method: 'get',
          url: 'expert/findProjectById',
          params: {projectid: this.$store.getters.expertLoginUser.pexpertprojectid}
        })
        this.project = res
        
      },
      async getAllpfList(){
        await this.getModel ()
        let data = await request({
          method: 'get',
          url: 'expert/getAllpfList',
          params: {
            projectid: this.$store.getters.expertLoginUser.pexpertprojectid,
            projectisqcheck: this.project.projectisqcheck,
            psupqcesresult: 1
          }
        })
        // if(+this.project.projectisqcheck === 1){
        //     this.psuList = data.psuList.filter(e => {
        //         return e.psupqcesresult == 1
        //     })
        // }
        // else{
        //
        // }
        this.psuList = data.psuList
        this.pgstList = data.pgstList
        this.pexertList = data.pexertList
        this.setCrossCols(data)
        this.totalScore(this.pgstList)
      },
      async setCrossCols(res){
          if(res.pexertList.length > 0){
            for(let i = 0;i < res.pexertList.length;i++){
              let item = res.pexertList[i]
              this.cols.push({
                  title:item.pexpertname ==  null?item.pexpertlogincode:item.pexpertname,
                  slots: {
                  default: 'default',
                  default: ({row}) => {
                    return this.getCrossCheckResultDesc({pexpertid:item.pexpertid,psucomid:row.psucomid})
                  }
                }
              })
            }
          }
          this.cols.push({field: 'psas', fieldtype: 'I', title: '最终得分', calculExpr: ''})
          this.cols.push({field: 'psseq', fieldtype: 'I', title: '排名', calculExpr: ''})
          this.cols.push({
                  title: '意见',
                  slots: {
                  default: 'default',
                  default: ({row}) => {
                    if(this.iscanbeEdit)
                      return [<el-input v-model={row.psdesc}></el-input>]
                    else
                      return row.psdesc
                  }
                }})
      },
      getCrossCheckResultDesc(item){
          let code = this.pgstList.filter(v => +v.pgsexpertid === +item.pexpertid && +v.pgscomid === +item.psucomid)
          let i = code.length > 0 ? code[0].pgsas:''
          return i
      },
      totalScore(e){
        let k = 0
        for(let i = 0;i < this.psuList.length; i++){
          let sum = 0
          for(let j = 0;j <this.pgstList.length; j++){

              if(this.psuList[i].psucomid === this.pgstList[j].pgscomid){
                sum += Number(this.pgstList[j].pgsas)
              }
          }
          this.psuList[i].psas = (sum/this.pexertList.length).toFixed(2)
        }
        let z = 0
        for(let i = 0;i < this.psuList.length;i++){
            for(let j =0;j <this.psuList.length;j++){
                  if(+this.psuList[i].psas < +this.psuList[j].psas){
                    z++
                  }
            }
              this.psuList[i].psseq = z+1
              z = 0
        }
        
        this.getpsrecList()
      },
      async getpsrecList(){

        let prsList = await request({
          method: 'get',
          url: 'expert/getpsrecList',
          params:{psprojectid: this.$store.getters.expertLoginUser.pexpertprojectid}
        })

        if(prsList.length>0){
          this.iscanbeEdit = false
          this.psuList.forEach(e => {
              e.psdesc = prsList.filter(v => +v.pscomid === +e.psucomid && +v.psprojectid === +e.psuprojectid)[0].psdesc
          });
        }

      },
      async saveSeq(){
        this.loading = true
        let pexerISstatus = this.pexertList.filter(v=>{
          return +v.pexpertpgsstatus === 2
        })
        if(this.pexertList.length !== pexerISstatus.length){
              this.$message.warning('尚有评审人未评分，请等候或者催促评审人评分');
              return
          }
          this.$confirm(`提交后不可修改，是否继续？`, '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(async () => {

                this.psuList.forEach(e=>e.psexpertid = this.$store.getters.expertLoginUser.pexpertid)

                let data = await request({
                  method: 'post',
                  url: 'expert/saveSeq',
                  data:this.psuList
                })

                if(data.issuccess === 1){
                  this.$message.success('提交成功')
                  this.totalScore(this.pgstList)
                }

              }).catch(() => {
          })

        this.loading = false
      },
      async cellClick (row) {
        this.model = row
      },
      async viewProject(row) {
        this.model = row
      },
      async pagechange (page) {
        this.query.offset = page.pageSize * (page.currentPage - 1)
        this.query.limit = page.pageSize
        this.getPageList()
      },
      async getPexertInfo () {
        let res = await request({
          method: 'get',
          url: 'expert/getPexertInfo',
          params: {pexpertid: this.$store.getters.expertLoginUser.pexpertid}
        })
        this.pexpertInfo = res
        if(this.pexpertInfo.pexpertmobile == null){
            this.$message.warning('请先填写评审人资料')
            this.$router.push({name: 'pExpertIndex', params: {}})
            return
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.btn{
  display: flex;
  justify-content: center;
  width: 100%;
  margin: 30px 0;
}
</style>